module.exports = __webpack_public_path__ + "static/media/Warning.ddbdc6a1.svg";